/*
 * bixdo Creator Stories 视频控制器。
 * 中文维护说明：仅在用户点击封面后加载外部播放器；同一时间只播放一张卡，兼容 Theme Editor 重载。
 */

(() => {
  if (window.BixdoHomeCreatorsVideoLoaded) return;
  window.BixdoHomeCreatorsVideoLoaded = true;

  const playSelector = '[data-bixdo-creator-play]';
  const mediaSelector = '[data-bixdo-creator-media]';

  const resetMedia = (media, restoreFocus = false) => {
    const player = media?.querySelector('[data-bixdo-creator-player]');
    const button = media?.querySelector(playSelector);
    if (!player) return;

    player.querySelectorAll('video').forEach((video) => {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {
        // 某些外部流媒体在元数据加载前不允许重置时间，忽略即可。
      }
    });

    player.querySelectorAll('[data-bixdo-creator-iframe]').forEach((iframe) => {
      iframe.removeAttribute('src');
    });

    player.hidden = true;
    media.classList.remove('is-playing');
    button?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) button?.focus();
  };

  const resetOtherMedia = (activeMedia) => {
    document.querySelectorAll(`${mediaSelector}.is-playing`).forEach((media) => {
      if (media !== activeMedia) resetMedia(media);
    });
  };

  const playMedia = (button) => {
    const media = button.closest(mediaSelector);
    const player = media?.querySelector('[data-bixdo-creator-player]');
    if (!media || !player) return;

    resetOtherMedia(media);

    const iframe = player.querySelector('[data-bixdo-creator-iframe]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }

    const directVideo = player.querySelector('[data-bixdo-creator-direct-video]');
    if (directVideo && !directVideo.getAttribute('src')) {
      directVideo.setAttribute('src', directVideo.dataset.src);
      directVideo.load();
    }

    player.hidden = false;
    media.classList.add('is-playing');
    button.setAttribute('aria-expanded', 'true');

    const video = player.querySelector('video');
    video?.addEventListener('ended', () => resetMedia(media), { once: true });
    video?.play().catch(() => {
      // 浏览器若阻止自动开始，原生 controls 仍允许用户手动播放。
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(playSelector);
    if (button) playMedia(button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const activeMedia = document.querySelector(`${mediaSelector}.is-playing`);
    if (activeMedia) resetMedia(activeMedia, true);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(`${mediaSelector}.is-playing`).forEach((media) => resetMedia(media));
  });
})();
